import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import '@/assets/index.css';
import App from '@/components/App/App';
import { BrowserRouter } from 'react-router-dom';

if (import.meta.env.DEV) {
  Sentry.init({
    dsn: import.meta.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100% of transactions for
    // performance monitoring. We recommend adjusting this value in production
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  });
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
